import {h} from 'preact'
import Popup from "./Popup";

export default ({open}) => {

    return (
        <Popup open={open} id="booking-created-popup" className="choose-popup">
            <div className="booking-created">
                <div className="card-box">
                    <div className="animation">
                        {open && <div className="success-checkmark" aria-hidden="true">✓</div>}
                    </div>
                    <h3>Booking created!</h3>
                    <p>Do you have any questions? Our manager<br/>will contact you soon.</p>
                </div>
            </div>
        </Popup>
    )
}